import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-table/react-table.css';
import { ConvertToOptions, CouponCampaignStatus } from '../../utils/enum';

class CouponCampaignFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      status: null,
    };
  }

  componentWillMount() {
    const { filters } = this.props;

    let filter = filters.find(f => f.field === 'name');
    if (filter) {
      this.setState({ name: filter.value });
    }
    filter = filters.find(f => f.field === 'status');
    if (filter) {
      this.setState({ status: filter.value });
    }
  }

  onSearch = () => {
    const { handleFiltersChange } = this.props;
    const {
      name, status,
    } = this.state;

    const filters = [];

    if (name) filters.push({ field: 'name', operator: '=', value: name });
    if (status) filters.push({ field: 'status', operator: '=', value: status });

    handleFiltersChange(filters);
  };

  onReset = () => {
    const { handleFiltersChange } = this.props;

    this.setState({
      name: '',
      status: null,
    });

    handleFiltersChange([]);
  };

  render() {
    const {
      name, status,
    } = this.state;

    return (
      <div>
        <div className="row m-b-sm p-l-md">
          <div className="col-lg-3 col-md-2 col-sm-6 col-xs-12" />
          <div className="col-lg-4 col-md-3 col-sm-6 col-xs-12">
            <div className="filter row">
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">Nosaukums:</div>
              <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <input onChange={e => this.setState({ name: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      this.onSearch();
                    }
                  }}
                  className="form-control"
                  value={name} />
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-3 col-sm-6 col-xs-12">
            <div className="filter row">
              <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">Statuss:</div>
              <div className="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                <Select options={ConvertToOptions(CouponCampaignStatus)}
                  placeholder=""
                  className="react-select-container form-control"
                  classNamePrefix="react-select"
                  value={ConvertToOptions(CouponCampaignStatus).find(option => option.value === status)}
                  isClearable
                  onChange={(selectedOptions) => {
                    const newValue = selectedOptions ? selectedOptions.value : null;
                    this.setState({ status: newValue });
                  }} />
              </div>
            </div>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-6 col-xs-12">
            <div className="filter row">
              <button type="button" onClick={this.onSearch}>
                Meklēt
              </button>
              <button type="button" onClick={this.onReset}>
                Notīrīt
              </button>
            </div>
          </div>
        </div>
        <hr className="line" />
      </div>
    );
  }
}

CouponCampaignFilter.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape()),
  handleFiltersChange: PropTypes.func.isRequired,
};

CouponCampaignFilter.defaultProps = {
  filters: [],
};

export default connect(
  state => ({
    filters: state.couponCampaign.filters,
  }),
  null,
)(CouponCampaignFilter);



// WEBPACK FOOTER //
// ./src/components/couponCampaign/Filter.jsx